
import React, { useState } from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { useSelector } from 'react-redux';
import URI from 'urijs';

import { PanelTitle } from '../../core';

import ShareOptions from './ShareOptions';

const SharePanel = (props) => {

    const classNames = mergeStyleSets({
        SharePanel: {
            padding: 4
        },
    });

    const [urlOptions, setUrlOptions] = useState({});
    const map = useSelector(state => state.map.map);
    const multiScene = useSelector(state => state.multiScene.multiScene);
    const mapMultiScene = useSelector(state => state.mapMultiScene.mapMultiScene);

    const getVisibleLayers = () => {
        return map.layers.filter(item => {
            return item.visible;
        }).map(item => item.id).join(',');
    }

    const getAngle = (angle) => {
        let angle2 = Math.round(MultiSceneCore.Utils.Math.rad2deg(
            MultiSceneCore.Utils.Math.normalizeAngle(angle)
        ));
        if (angle2 > 180) {
            angle2 = angle2 - 360;
        }
        return angle2;
    }

    const getUrl = () => {
        let url = new URI(window.location.href);
        let params = {
            x: null,
            y: null,
            zoom: null,
            layers: null,
            mms: null
        };
        if (urlOptions.center) {
            params.x = Math.trunc(map.center[0]);
            params.y = Math.trunc(map.center[1]);
        }
        if (urlOptions.zoom) {
            params.zoom = Math.trunc(map.zoom);
        }
        if (urlOptions.layers) {
            params.layers = getVisibleLayers();
        }
        if (urlOptions.mms) {
            if (mapMultiScene.mmsPoint) {
                let values = mapMultiScene.mmsPoint;
                params.mms = [
                    values.trj_name, values.photo_name
                ].join(';');

                params.yaw = getAngle(mapMultiScene.cameraParams.cameraRotation.yaw);
                params.pitch = getAngle(mapMultiScene.cameraParams.cameraRotation.pitch);
                params.mode = multiScene.mode;
            }
        }
        for (let name in params) {
            if (params[name]) {
                url.setSearch(name, params[name]);
            } else {
                url.removeSearch(name);
            }
        }
        return url.toString();
    }

    const handleChange = (options) => {
        setUrlOptions(options);
    }

    const handleCopy = (event) => {
        const el = document.createElement('textarea');
        el.value = getUrl();
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

    return (
        <Stack verticalFill className={classNames.SharePanel} tokens={{childrenGap: 4}}>
            <Stack.Item align="stretch">
                <PanelTitle title="SDÍLENÍ AKTUÁLNÍHO STAVU" />
            </Stack.Item>
            <Stack.Item>
                <ShareOptions
                    visibleMultiScene={!!mapMultiScene.mmsPoint}
                    onChange={handleChange}
                />
            </Stack.Item>
            <Stack.Item>
                <TextField
                    label="URL adresa"
                    value={getUrl()}
                    readOnly={true}
                    multiline={true}
                    rows={10}
                    wrap="n"
                    styles={{field: {fontFamily: 'Monospace'}}}
                />
            </Stack.Item>
            <Stack.Item>
                <PrimaryButton onClick={handleCopy}>Kopírovat</PrimaryButton>
            </Stack.Item>
        </Stack>
    );
}

export default SharePanel;
